import { BaseModel } from "../../normalized/models";

export class Employee extends BaseModel {
    id: string;
    name: string;
    notAvailableDates: string[];
    isActive: boolean;
}
